import { oc } from "@orpc/contract";
import { z } from "zod";

// ============================================================================
// Suggest Growth Baseline - Get prior year data for growth rule baseline
// ============================================================================

export const SuggestGrowthBaselineRequestSchema = z.object({
  agreementId: z.uuid(),
  divisionIds: z.array(z.uuid()),
  qualifyingProductGroupIds: z.array(z.uuid()),
  qualifyingInclusionType: z.enum(["inclusive", "exclusive"]),
  affectedProductGroupIds: z.array(z.uuid()),
  affectedInclusionType: z.enum(["inclusive", "exclusive"]),
});

export const SuggestGrowthBaselineResponseSchema = z.object({
  status: z.enum([
    "success",
    "multiple_agreements",
    "no_prior_agreement",
    "no_matching_rule",
  ]),
  message: z.string().optional(),
  suggestions: z
    .object({
      actuals: z.object({
        value: z.number(),
        monthsOfData: z.number(),
        lastDataMonth: z.string(),
      }),
      predicted: z.object({
        value: z.number(),
      }),
    })
    .optional(),
  matchedRule: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .optional(),
  priorYearAgreement: z
    .object({
      id: z.string(),
      name: z.string(),
      year: z.number(),
    })
    .optional(),
});

// ============================================================================
// Contract Definitions
// ============================================================================

export const growthBaselineSuggestionContracts = {
  suggest: oc
    .input(SuggestGrowthBaselineRequestSchema)
    .output(SuggestGrowthBaselineResponseSchema)
    .route({ method: "POST" }),
} as const;

// ============================================================================
// Type Exports
// ============================================================================

export type SuggestGrowthBaselineRequest = z.infer<
  typeof SuggestGrowthBaselineRequestSchema
>;
export type SuggestGrowthBaselineResponse = z.infer<
  typeof SuggestGrowthBaselineResponseSchema
>;
